import axios from '@fs/zion-axios'
import { relativesConfig } from '../../config'
import SERVICE from './serviceName'
import { getEnv } from '../../lib/helpers/urlHelpers'

const { eventIds } = relativesConfig

// DOCS: https://www.familysearch.org/service/orchestration/relatives-at-event/
const BASE = `${SERVICE}/relatives-at-event/event`
const EVENT = `${BASE}/${eventIds[getEnv()]}`
const COUNTRIES = `${EVENT}/places/countries`

export const getEventAttendeeCounts = async () => {
  return axios.get(`${EVENT}/attendees/counts`)
}
export const getRaeCountries = async () => {
  return axios.get(`${COUNTRIES}`)
}
export const getRaeProvinces = async (countryId) => {
  return axios.get(`${COUNTRIES}/${countryId}/states-provinces`)
}
